import { render } from "./SubmitArticle.vue?vue&type=template&id=582a32b5&scoped=true"
import script from "./SubmitArticle.vue?vue&type=script&lang=js"
export * from "./SubmitArticle.vue?vue&type=script&lang=js"

import "./SubmitArticle.vue?vue&type=style&index=0&id=582a32b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582a32b5"]])

export default __exports__